var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlphabet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 24,
    viewBox: "0 0 236 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7535 0.03125L21.3368 14.9996H8.16652L14.7535 0.03125H10.7132L0 23.967H4.21955L6.9716 17.694H22.5317L25.2875 23.967H29.5033L18.7901 0.03125H14.7535Z",
    fill: "#F17030"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.562 0.0351562L141.145 15.0035H127.975L134.562 0.0351562H130.522L119.809 23.9709H124.028L126.78 17.6979H142.344L145.096 23.9709H149.316L138.599 0.0351562H134.562Z",
    fill: "#F17030"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.695 0V24H172.759C175.985 24 178.92 22.137 178.92 18.5999C178.92 14.5791 176.153 12.0019 172.206 12.0019C174.753 11.4955 178.92 10.8833 178.92 5.40387C178.92 1.86301 175.989 0.00377893 172.759 0.00377893H152.695V0ZM170.712 2.70572C173.091 2.70572 174.917 3.94143 174.917 6.53377C174.917 9.12612 173.091 10.4639 170.712 10.4639H156.553V2.70572H170.712ZM170.712 13.5361C173.091 13.5361 174.917 14.9154 174.917 17.4662C174.917 20.017 173.091 21.2943 170.712 21.2943H156.553V13.5361H170.712Z",
    fill: "#F17030"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.195 23.9782V20.8908H188.326V13.3821H206.859V10.2947H188.326V3.11095H208.195V0.0273438H184.469V23.9782H208.195Z",
    fill: "#F17030"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.825 23.9709V0.0351562H110.967V10.2912H91.6732V0.0351562H87.8047V23.9709H91.6732V13.3748H110.967V23.9709H114.825Z",
    fill: "#F17030"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4527 23.9782V20.8946H36.9628V0.0273438H33.1055V23.9782H53.4527Z",
    fill: "#F17030"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.759 23.9782V3.11095H235.998V0.0273438H212.305V3.11095H221.886V23.9782H225.759Z",
    fill: "#F17030"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8281 0.0273438V23.9782H60.6855V16.2465H72.1193C78.0865 16.2465 84.1843 15.6079 84.1843 8.13693C84.1843 0.665983 78.0865 0.0386805 72.1193 0.0386805C66.1522 0.0386805 62.8587 0.0273438 56.8281 0.0273438ZM60.6855 3.20165H74.1395C77.25 3.20165 80.1962 4.54317 80.1962 8.13315C80.1962 11.7231 77.2388 13.0647 74.1395 13.0647H60.6855V3.20165Z",
    fill: "#F17030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabet);
export default __webpack_public_path__ + "static/media/alphabet.608eaaf68f85e029b99a7b7347a727c7.svg";
export { ForwardRef as ReactComponent };